import { render } from "./EnergyLabel.vue?vue&type=template&id=20fb0c1e&scoped=true"
import script from "./EnergyLabel.vue?vue&type=script&lang=js"
export * from "./EnergyLabel.vue?vue&type=script&lang=js"

import "./EnergyLabel.vue?vue&type=style&index=0&id=20fb0c1e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20fb0c1e"]])

export default __exports__